var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRepeatYourself(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502 305.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#6efaff;}.cls-3{fill:none;stroke:#6efaff;stroke-miterlimit:10;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeat_yourself",
    "data-name": "repeat yourself"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.24,98.77c0,1.12-.05,2.22-.14,3.31a39.44,39.44,0,0,1-37.55,36.11c-.59,0-1.18,0-1.77,0s-1.19,0-1.78,0a39.45,39.45,0,0,1-37.54-36.11c-.09-1.09-.14-2.19-.14-3.31a38.8,38.8,0,0,1,.22-4.19A39.46,39.46,0,0,1,155,94c0,.26.06.51.09.77C155.17,96.09,155.24,97.42,155.24,98.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.89,104.76c0,1.12-.05,2.22-.14,3.31a39.47,39.47,0,0,1-37.55,36.11c-.59,0-1.18,0-1.77,0s-1.19,0-1.78,0a39.45,39.45,0,0,1-37.54-36.11c-.09-1.09-.14-2.19-.14-3.31a38.8,38.8,0,0,1,.22-4.19,39.46,39.46,0,0,1,78.5.19C443.82,102.08,443.89,103.41,443.89,104.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.24,98.77c0,1.12-.05,2.22-.14,3.31a39.44,39.44,0,0,1-37.55,36.11c-.59,0-1.18,0-1.77,0s-1.19,0-1.78,0a39.45,39.45,0,0,1-37.54-36.11c-.09-1.09-.14-2.19-.14-3.31a38.8,38.8,0,0,1,.22-4.19A39.46,39.46,0,0,1,155,94c0,.26.06.51.09.77C155.17,96.09,155.24,97.42,155.24,98.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.03,
    y: 146.26,
    width: 84.99,
    height: 138.08,
    rx: 6.25,
    transform: "translate(32.04 -11.24) rotate(8.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.02,
    y: 143.86,
    width: 79.42,
    height: 23.42,
    rx: 10.97,
    transform: "translate(-43.61 65.54) rotate(-20.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 356.02,
    y: 187.48,
    width: 91.7,
    height: 26.12,
    rx: 10.97,
    transform: "matrix(0.83, -0.56, 0.56, 0.83, -43.53, 258.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.57,
    y: 184.59,
    width: 86.29,
    height: 26.12,
    rx: 10.97,
    transform: "translate(213.25 -179.6) rotate(40.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -39.56,
    y: 202.38,
    width: 157.88,
    height: 21.95,
    rx: 10.97,
    transform: "translate(-170.89 159.93) rotate(-65.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155,94.77c.13,1.32.2,2.65.2,4,0,1.12-.05,2.22-.14,3.31A39.24,39.24,0,0,1,149.69,119l-7.37-7.37A11,11,0,0,1,155,94C155,94.26,155,94.51,155,94.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.69,152.44a11,11,0,0,1-15.52,0l-26.66-26.66a48.49,48.49,0,0,0,8-22.91c0-.05,0-.09,0-.14l34.19,34.19A11,11,0,0,1,198.69,152.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.69,212.63c15.44,42.08,19.21,81.94-5.53,91s-52.6-23.19-68-65.28-24.74-77,0-86.06S474.26,170.54,489.69,212.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "357.6 153.56 259.17 168.25 259.17 102.73 357.6 116.37 357.6 153.56"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 310.84,
    cy: 152.08,
    r: 31.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "350.72 58.6 287.1 6.65 293.09 0 354.94 55.87 350.72 58.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "338.36 76.46 259.17 54.67 261.95 46.17 341.12 72.25 338.36 76.46"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRepeatYourself);
export default __webpack_public_path__ + "static/media/ic_repeatYourself.fe97510acddbe8001588594bba8d6ef6.svg";
export { ForwardRef as ReactComponent };